import analytics from "@/utils/analytics";
import { useThemeContext } from "@cohesive/ui-components";
import { useCallback } from "react";

export function useToggleTheme() {
  const { mode, setMode } = useThemeContext();

  const toggleTheme = useCallback(() => {
    const newMode = mode === "light" ? "dark" : "light";
    document.body.classList.add("disable-transitions");
    setMode(newMode);
    setTimeout(() => {
      document.body.classList.remove("disable-transitions");
    }, 1000);
    analytics.trackLightDarkModeToggle({ mode: newMode });
  }, [mode, setMode]);

  return { toggleTheme };
}
